import { call, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import FinancialStatementFactory from "../../Entity/Factories/FinancialStatementFactory";

export default function* financialStatementsNotSaveList(action: ActionInterface): any {
  try {
    let request = "financial-statements?";

    typeof action.payload?.sortBy !== "undefined" ?
            request += `&sort_by=${action.payload?.sortBy}` : "sort_by=firstDate";

    typeof action.payload?.offset !== "undefined" ?
						request += `&offset=${action.payload?.offset}` : request;

		typeof action.payload?.limit !== "undefined" ?
						request += `&limit=${action.payload?.limit}` : request;

    typeof action.payload?.ownerId !== "undefined" ?
            request += `&owner_id=${action.payload?.ownerId}` : request;

    typeof action.payload?.firstItem !== "undefined" ?
            request += `&first_item=${action.payload?.firstItem}` : request;

    typeof action.payload?.lastItem !== "undefined" ?
            request += `&last_item=${action.payload?.lastItem}` : request;

    typeof action.payload?.isSent !== "undefined" ?
            request += `&is_sent=${action.payload?.isSent}` : request;

    typeof action.payload?.afterInvoiceNumberStartDate !== "undefined" ?
            request += `&after_invoice_number_start_date=1` : request;        

    typeof action.payload?.isSnoozed !== "undefined" ?
            request += `&is_snoozed=${action.payload?.isSnoozed}` : request;

    typeof action.payload?.filterValue !== "undefined" ?
						request += `&q=${action.payload?.filterValue}` : request;

    typeof action.payload?.period !== "undefined" ?
						request += `&period=${action.payload?.period}` : request;

    const res = yield call(Http.get, request);

    const financialStatements = res.data.data.rows.map(financialStatement => {
      return FinancialStatementFactory.create(financialStatement);
    });

    const payload: any = {
      financialStatements: financialStatements,
      count: res.data.data.count,
      request: request
    };

    if (action.hasOwnProperty("onSuccess")) {
      action.onSuccess.call(this, {...payload});
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);
  }
}

export function* watchFinancialStatementsNotSaveList() {
  yield takeEvery(Constants.GLOBAL_FINANCIAL_STATEMENTS_NOT_SAVE_LIST, financialStatementsNotSaveList);
}
